import React, { useEffect, useState } from "react";
import "./productExperienceDms.css";

import customerHierarchy from "../../assets/webScreenshots/customerHierarchy.png";
import dailyVisitSummaryDashboard from "../../assets/webScreenshots/dailyVisitSummaryDashboard.png";
import liveTracking from "../../assets/webScreenshots/liveTracking.png";
import visitActivity from "../../assets/webScreenshots/visitActivity.png";

import attendanceScreen from "../../assets/mobileScreenshots/attendanceScreen.jpg";
import homescreen from "../../assets/mobileScreenshots/Homescreen.jpg";
import loginScreen from "../../assets/mobileScreenshots/loginScreen.jpg";
import outletMap from "../../assets/mobileScreenshots/OutletMap.jpg";
import todaysVisitMap from "../../assets/mobileScreenshots/todaysVisitMap.jpg";

import { FiMonitor, FiSmartphone, FiArrowRight } from "react-icons/fi";
import DmsBookingModal from "./dmsBookingModal";

const webScreens = [
  {
    image: liveTracking,
    title: "Live Tracking",
    text: "Monitor your sales team in real time.",
  },
  {
    image: visitActivity,
    title: "Visit Activity",
    text: "Track field visits and sales activity.",
  },
  {
    image: customerHierarchy,
    title: "Customer Hierarchy",
    text: "Manage your distribution network.",
  },
  {
    image: dailyVisitSummaryDashboard,
    title: "Visit Summary",
    text: "See daily field performance at a glance.",
  },
];

const mobileScreens = [
  {
    image: loginScreen,
    title: "DMS Login",
    text: "Secure access for your sales team.",
  },
  {
    image: homescreen,
    title: "DMS Dashboard",
    text: "Orders, visits, outlets and billing at a glance.",
  },
  {
    image: todaysVisitMap,
    title: "Today's Visits",
    text: "Plan and manage retailer visits on the map.",
  },
  {
    image: outletMap,
    title: "Outlet Mapping",
    text: "View and manage outlets across your territory.",
  },
  {
    image: attendanceScreen,
    title: "Attendance",
    text: "Track field attendance and daily activity.",
  },
];

const ProductExperienceDms = () => {
  const [webIndex, setWebIndex] = useState(0);
  const [mobileIndex, setMobileIndex] = useState(0);

  useEffect(() => {
    const webTimer = setInterval(() => {
      setWebIndex((prev) => (prev + 1) % webScreens.length);
    }, 4500);

    const mobileTimer = setInterval(() => {
      setMobileIndex((prev) => (prev + 1) % mobileScreens.length);
    }, 3800);

    return () => {
      clearInterval(webTimer);
      clearInterval(mobileTimer);
    };
  }, []);

  const activeWeb = webScreens[webIndex];
  const activeMobile = mobileScreens[mobileIndex];
  const [showDmsModal, setShowDmsModal] = useState(false);

  const handleEnquiry = () => {
    const enquiryButton = document.querySelector("#enquiry-button");

    if (enquiryButton) {
      enquiryButton.click();
    }
  };
  return (
    <>
      <section className="product-experience-dms-section">
        <div
          className="product-experience-dms-glow product-glow-one"
          aria-hidden="true"
        ></div>
        <div
          className="product-experience-dms-glow product-glow-two"
          aria-hidden="true"
        ></div>
        <div className="container">
          <div
            className="product-experience-dms-heading"
            data-aos="fade-up"
            data-aos-duration="850"
          >
            <span className="product-experience-dms-label">
              SEE DMS IN ACTION
            </span>
            <h2>
              Your Distribution Network.
              <br />
              <span>One Connected Platform.</span>
            </h2>
            <p>
              Powerful web and mobile experiences built for distribution teams.
            </p>
          </div>
          <div className="product-experience-dms-devices">
            <div
              className="product-dms-web"
              data-aos="fade-right"
              data-aos-duration="950"
            >
              <div className="product-device-heading">
                <div className="product-device-icon">
                  <FiMonitor />
                </div>
                <div>
                  <span>WEB PLATFORM</span>
                  <strong>{activeWeb.title}</strong>
                </div>
              </div>
              <div className="dms-laptop">
                <div className="dms-laptop-screen">
                  <div className="dms-laptop-camera"></div>
                  <div className="dms-laptop-browser">
                    <div className="dms-browser-bar">
                      <div className="dms-browser-dots">
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                      <div className="dms-browser-address">techcognics DMS</div>
                    </div>
                    <div className="dms-web-image-wrap">
                      <img
                        key={activeWeb.image}
                        src={activeWeb.image}
                        alt={activeWeb.title}
                      />
                    </div>
                  </div>
                </div>
                <div className="dms-laptop-base">
                  <div className="dms-laptop-hinge"></div>
                  <div className="dms-laptop-base-center"></div>
                </div>
              </div>
              <div className="product-device-caption">
                <strong>{activeWeb.title}</strong>
                <span>{activeWeb.text}</span>
              </div>
              <div className="product-device-dots">
                {webScreens.map((screen, index) => (
                  <button
                    key={screen.title}
                    type="button"
                    className={index === webIndex ? "active" : ""}
                    onClick={() => setWebIndex(index)}
                    aria-label={`Show ${screen.title}`}
                  />
                ))}
              </div>
            </div>
            <div
              className="product-dms-mobile"
              data-aos="fade-left"
              data-aos-duration="950"
              data-aos-delay="150"
            >
              <div className="product-device-heading">
                <div className="product-device-icon mobile-icon">
                  <FiSmartphone />
                </div>
                <div>
                  <span>MOBILE APP</span>
                  <strong>{activeMobile.title}</strong>
                </div>
              </div>
              <div className="dms-phone-stage">
                <div className="dms-phone">
                  <div className="dms-phone-frame">
                    <div className="dms-phone-speaker"></div>
                    <div className="dms-phone-camera"></div>
                    <div className="dms-phone-screen">
                      <img
                        key={activeMobile.image}
                        src={activeMobile.image}
                        alt={activeMobile.title}
                      />
                    </div>
                    <div className="dms-phone-home"></div>
                  </div>
                </div>
              </div>
              <div className="product-device-caption mobile-caption">
                <strong>{activeMobile.title}</strong>
                <span>{activeMobile.text}</span>
              </div>
              <div className="product-device-dots">
                {mobileScreens.map((screen, index) => (
                  <button
                    key={screen.title}
                    type="button"
                    className={index === mobileIndex ? "active" : ""}
                    onClick={() => setMobileIndex(index)}
                    aria-label={`Show ${screen.title}`}
                  />
                ))}
              </div>
            </div>
          </div>

          <div
            className="product-experience-dms-bottom"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <span>Manage</span>
            <FiArrowRight />
            <span>Sell</span>
            <FiArrowRight />
            <span>Track</span>
            <FiArrowRight />
            <span className="highlight">Grow</span>
          </div>
          <div
            className="product-experience-dms-cta"
            data-aos="fade-up"
            data-aos-duration="800"
            data-aos-delay="350"
          >
            <button
              type="button"
              className="product-experience-dms-cta-btn"
              onClick={() => setShowDmsModal(true)}
            >
              See DMS in Action
              <span>
                <FiArrowRight />
              </span>
            </button>
          </div>
        </div>
      </section>
      <DmsBookingModal
        show={showDmsModal}
        onClose={() => setShowDmsModal(false)}
      />
    </>
  );
};

export default ProductExperienceDms;
